'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

// The DaysByDate component calculates and displays information
// about a date based on either the endDate or the numberOfDays
// prop. The component handles different cases, such as "Today"
// and "Tomorrow", and displays the estimatedDate in ISO string format for other cases.
export const DaysByDate = ({
  endDate,
  numberOfDays,
}: {
  endDate?: Date;
  numberOfDays?: number;
}) => {
  const t = useTranslations('ring');
  const [estimatedDate, setEstimatedDate] = useState<Date | null>(null);
  const [days, setDays] = useState<number | null>(null);

  const dateFormatter = new Intl.DateTimeFormat('en', {
    day: 'numeric',
    month: 'short',
  });

  useEffect(() => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (numberOfDays) {
      const estDate =
        currentDate.getTime() + numberOfDays * 24 * 60 * 60 * 1000;
      setEstimatedDate(new Date(estDate));
      setDays(numberOfDays);
    } else {
      if (endDate) {
        const dateToCompare = new Date(endDate);
        dateToCompare.setHours(0, 0, 0, 0);
        const diff = Math.abs(endDate.getTime() - currentDate.getTime());
        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        setDays(d);
        setEstimatedDate(new Date(endDate));
      }
    }
  }, [endDate]);

  return (function () {
    switch (days) {
      case 0:
        return (
          <span>
            {/* Today,{' '} */}
            {t('ring.TODAY')},{' '}
            {estimatedDate && dateFormatter.format(estimatedDate as Date)}
          </span>
        );
      case 1:
        return (
          <span>
            {/* Tomorrow,{' '} */}
            {t('ring.TOMORROW')},{' '}
            {estimatedDate && dateFormatter.format(estimatedDate as Date)}
          </span>
        );
      case 2:
        return (
          <span>
            {/* In 2 days,{' '} */}
            {t('ring.IN_TWO_DAYS')},{' '}
            {estimatedDate && dateFormatter.format(estimatedDate as Date)}
          </span>
        );
      default:
        return (
          <span>
            {estimatedDate && dateFormatter.format(estimatedDate as Date)}
          </span>
        );
    }
  })();
};
